var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-top bg-inverse d-flex justify-content-end align-items-center m-3 ml-auto",attrs:{"id":"customer-area"}},[_c('span',{staticClass:"mr-1"},[_c('small',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.__('navigation.customer-area')))])]),_vm._v(" "),_c('span',{staticClass:"icon-user text-white text-center"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ce7100","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CustomerAreaButton.vue
// module id = DhCa
// module chunks = 0